import { Box } from '@mui/material';
import Script from 'next/script';
import React from 'react';
import { deprecatedColors } from 'styles/theme/deprecatedColors';

type WordPressContentProps = {
    content: string;
    elementorStyles?: string[];
    elementorCss?: string | null;
    elementorScripts?: string[];
    elementorConfig?: string | null;
};

function WordpressContent(props: WordPressContentProps) {
    const { content, elementorCss, elementorScripts, elementorConfig } = props;

    return (
        <>
            {elementorCss && (
                <style dangerouslySetInnerHTML={{ __html: elementorCss }} />
            )}
            {/*
             * WP-innehållet renderas i .wp-wrapper, men CMS-temats innehållsstilar
             * är scopade under .wp-content — därför får inbäddade länkar ingen färg
             * och blir oskiljbara från brödtexten. Ge dem CMS-temats länkfärg
             * (netconsult-marykay: $mk-pink-05 / #E74683 = deprecatedColors.secondary5).
             */}
            <Box
                sx={{ overflow: 'hidden', '& a': { color: deprecatedColors.secondary5 } }}
                className="wp-wrapper"
                dangerouslySetInnerHTML={{ __html: content }}
            />
            {elementorConfig && (
                // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
                <Script
                    id="elementor-frontend-config"
                    strategy="beforeInteractive"
                    dangerouslySetInnerHTML={{
                        __html: `var elementorFrontendConfig = ${elementorConfig};`,
                    }}
                />
            )}
            {elementorScripts?.map((src) => (
                <Script key={src} src={src} strategy="afterInteractive" />
            ))}
        </>
    );
}

export default WordpressContent;
